import {LearnPage,DigitalVaultPage,DigitalAssetDetailPage,MarketplacePage,MarketplaceProductPage,CustomerDashboard,PdfToolsHub,PdfToolPage,PdfWorkflowBuilder,MarketDashboard,StudioPage} from './route-components.jsx';
import HostingerReferral from './HostingerReferral.jsx';
import {AdSlot,GrowthAuditModal} from './Monetization.jsx';
import {trackLeadEvent} from './utils/tracking.js';
import React,{useState,useEffect,lazy,Suspense} from 'react';
import {ArrowUpRight,ArrowRight,Search,Menu,X,Layers,Workflow,BookOpen,Calculator,Sparkles,Clock,Check,ChevronRight} from 'lucide-react';
import {plain} from '../shared/seo.mjs';
import {ToolWorkspace,isTool} from './Tools.jsx';
import {PlatformHeader,PlatformHome,PlatformDirectory,PlatformToolPage,PlatformSearch,ShopPage,ShopProductPage} from './Platform.jsx';
const Admin=lazy(()=>import('./Admin.jsx'));
const CrmApp=lazy(()=>import('./crm/CrmApp.jsx'));
import {categories as toolCategories} from '../shared/tool-registry.mjs';
import { LiveMarketTicker } from './markets/LiveMarketTicker.jsx';
import PublicSearchContent from './PublicSearchContent.jsx';
import {publicReadingMinutes} from '../shared/public-search-content.mjs';
import {articleNavigation} from '../shared/article-navigation.mjs';
import ArticleContents from './ArticleContents.jsx';
import FuturisticBlogHub, { FuturisticCard, FuturisticArticleReaderHUD, CyberAudioBriefingBar, CyberAuthorDossier } from './BlogFuturistic.jsx';
export function Brand({settings}){return <a className="brand" href="/" aria-label={`${settings.siteName} home`}><img className="brand-logo-light" src="/brand/bizaipro-logo-448.webp" srcSet="/brand/bizaipro-logo-224.webp 224w, /brand/bizaipro-logo-448.webp 448w" sizes="(max-width:600px) 110px, 193px" alt={settings.siteName} width="1120" height="293"/><img className="brand-logo-dark" src="/brand/bizaipro-logo-white-448.webp" srcSet="/brand/bizaipro-logo-white-224.webp 224w, /brand/bizaipro-logo-white-448.webp 448w" sizes="(max-width:600px) 110px, 193px" alt={settings.siteName} width="1120" height="293"/></a>;}
function Card({post,index=0}){return <FuturisticCard post={post} index={index}/>;}
function Header({settings}){const [open,setOpen]=useState(false);return <><div className="topline">Practical AI. Real business progress. <a href="/blog/">Find your next workflow <ArrowUpRight size={12}/></a></div><header className="site-header"><div className="container header-inner"><Brand settings={settings}/><nav className={open?'nav open':'nav'} aria-label="Main navigation">{settings.navigation.map(n=><a key={n.url} href={n.url}>{n.label}</a>)}</nav><div className="header-actions"><a href="/search/" aria-label="Search articles"><Search size={20}/></a><a className="button dark small" href="/free-tools/">Find your tool <ArrowUpRight size={15}/></a><button className="mobile-toggle icon-button" onClick={()=>setOpen(!open)} aria-label="Toggle navigation" aria-expanded={open}>{open?<X/>:<Menu/>}</button></div></div></header></>;}
function Home({data}){const posts=data.posts||[];return <><section className="hero container"><div className="hero-copy"><div className="eyebrow"><span className="live-dot"/>{data.settings.heroEyebrow}</div><h1>{data.settings.heroTitle}</h1><p>{data.settings.heroDescription}</p><div className="hero-buttons"><a className="button" href={data.settings.heroButtonUrl}>{data.settings.heroButton}<ArrowUpRight size={18}/></a><a className="text-link" href="/free-tools/">Try a free tool <ArrowRight size={17}/></a></div><div className="hero-note"><span className="check-disc"><Check size={14}/></span> Built for small businesses. Written for humans.</div></div><div className="hero-visual"><div className="visual-grid"/><div className="orbit orbit-one"/><div className="orbit orbit-two"/><div className="workflow-card"><div className="workflow-top"><span className="mini-icon"><Workflow size={20}/></span><span>YOUR NEXT SMARTER WORKFLOW</span><span className="live-dot"/></div><h2>From busywork<br/>to better work.</h2><div className="workflow-step"><span>01</span><div><b>Find the opportunity</b><small>Start with one repetitive task</small></div><Check size={17}/></div><div className="workflow-step"><span>02</span><div><b>Choose your tools</b><small>A practical stack that fits</small></div><Check size={17}/></div><div className="workflow-step active"><span>03</span><div><b>Make progress</b><small>Test, measure, improve</small></div><ArrowUpRight size={17}/></div><div className="workflow-foot"><span className="live-dot"/> SMALL STEPS. LASTING IMPACT.</div></div><div className="float-label"><Sparkles size={16}/> A little AI. A lot of possibility.</div></div></section><section className="topic-band"><div className="container topic-grid">{[[Layers,'Find the right tools','Compare your options','/ai-tools/'],[Workflow,'Automate the everyday','Workflows you can use','/business-automation/'],[BookOpen,'Learn by doing','Practical, clear guides','/blog/'],[Calculator,'Make better decisions','Free business calculators','/tools/']].map(([Icon,title,desc,url])=><a href={url} key={url}><Icon size={25} strokeWidth={1.6}/><div><strong>{title}</strong><span>{desc}</span></div><ArrowUpRight size={17}/></a>)}</div></section><section className="container section"><div className="section-heading"><div><span className="eyebrow">THE BIZAIPRO JOURNAL</span><h2>Good ideas. Useful next steps.</h2></div><a className="text-link" href="/blog/">All guides <ArrowRight size={17}/></a></div>{posts.length?<div className="card-grid">{posts.slice(0,6).map((p,i)=><Card key={p._id} post={p} index={i}/>)}</div>:<p className="empty-state">New guides are on the way. Explore the free tools to get started.</p>}</section><section className="container"><div className="tools-banner"><div><span className="eyebrow">LESS GUESSWORK. MORE CLARITY.</span><h2>Useful tools.<br/>Zero subscription.</h2><p>Calculate your returns, plan a campaign, or tidy up your content. Get straight to work.</p><a className="button dark" href="/free-tools/">Explore the toolbox <ArrowUpRight size={18}/></a></div><div className="tool-tiles"><a href="/tools/roas-calculator/"><Calculator/>ROAS Calculator<ArrowUpRight/></a><a href="/tools/utm-builder/"><Workflow/>UTM Builder<ArrowUpRight/></a><a href="/tools/word-counter/"><BookOpen/>Word Counter<ArrowUpRight/></a></div></div></section></>;}
function Article({data}){
  const p=data.post;
  const tool=isTool(p.slug);
  const reading=articleNavigation(p.content);
  return <>
    {p.kind==='post'&&<FuturisticArticleReaderHUD title={p.title} slug={p.slug} excerpt={p.excerpt}/>}
    <div className="container article-layout">
      <article>
        <nav className="breadcrumbs">
          <a href="/">Home</a>
          <ChevronRight size={13}/>
          <a href={tool?'/tools/':'/blog/'}>{tool?'Free tools':p.kind==='post'?'Journal':'Pages'}</a>
          {p.category&&<><ChevronRight size={13}/><span style={{color:'var(--apple-blue)'}}>{p.category}</span></>}
        </nav>
        {data.preview&&<div className="notice">Private preview — this does not publish your changes.</div>}
        <header className="article-heading" style={{marginBottom:'24px'}}>
          <span className="apple-eyebrow" style={{marginBottom:'10px'}}>
            {p.category||'Guides'}
          </span>
          <h1 style={{fontSize:'clamp(2rem, 3.8vw, 3rem)',fontWeight:'700',lineHeight:'1.15',letterSpacing:'-0.025em',margin:'0 0 16px'}}>{p.title}</h1>
          {p.excerpt&&<p className="article-deck" style={{fontSize:'16px',lineHeight:'1.6',color:'var(--apple-text-secondary)',margin:'0 0 20px'}}>{p.excerpt}</p>}
          {p.kind==='post'&&<div className="article-meta" style={{display:'flex',alignItems:'center',gap:'12px',flexWrap:'wrap',padding:'14px 0',borderTop:'1px solid var(--apple-divider)',borderBottom:'1px solid var(--apple-divider)',fontSize:'13px',color:'var(--apple-text-tertiary)'}}>
            <span className="apple-author-avatar" style={{width:'32px',height:'32px',fontSize:'13px'}}>B</span>
            <span style={{fontWeight:'600',color:'var(--apple-text-primary)'}}>{p.author||'BizAIPro Editorial'}</span>
            <span>·</span>
            <span><Clock size={13} style={{verticalAlign:'-2px',marginRight:'4px'}}/>{publicReadingMinutes(plain(p.content),p.slug,data.preview)} min read</span>
            <span>·</span>
            <span>{p.publishedAt?new Date(p.publishedAt).toLocaleDateString('en-US',{timeZone:'UTC',month:'short',day:'numeric',year:'numeric'}):'Draft'}</span>
          </div>}
        </header>
        {p.kind==='post'&&<CyberAudioBriefingBar title={p.title} excerpt={p.excerpt}/>}
        {tool?<ToolWorkspace slug={p.slug} settings={data.settings}/>:null}
        {(!tool&&p.featuredImage)&&<div style={{position:'relative',borderRadius:'20px',overflow:'hidden',marginBottom:'36px',border:'1px solid var(--apple-card-border)'}}>
          <img className="article-featured" src={p.featuredImage} alt={p.imageAlt||p.title} width="1200" height="675" style={{display:'block',width:'100%',margin:0}}/>
        </div>}
        {p.kind==='post'&&<ArticleContents headings={reading.headings}/>}
        <div className="prose" dangerouslySetInnerHTML={{__html:reading.html}}/>
        {p.kind==='post'&&<CyberAuthorDossier author={p.author} date={p.publishedAt||p.updatedAt}/>}
        {!data.preview&&<PublicSearchContent slug={p.slug}/>}
      </article>
      <aside className="article-sidebar">
        <span className="apple-eyebrow">Interactive Workflows</span>
        <h3 style={{fontSize:'18px',fontWeight:'700',margin:'8px 0 12px'}}>Turn insight into progress.</h3>
        <p style={{fontSize:'13.5px',lineHeight:'1.55',color:'var(--apple-text-secondary)',margin:'0 0 18px'}}>Explore tested automation calculators and business tools with zero signup required.</p>
        <a className="apple-btn-primary" href="/free-tools/" style={{width:'100%',justifyContent:'center',boxSizing:'border-box'}}>
          <span>Explore All Tools</span>
          <ArrowUpRight size={15}/>
        </a>
        <div className="sidebar-ad-box"><AdSlot settings={data.settings} slot={data.settings.adsenseSidebarSlot} type="sidebar"/></div>
      </aside>
    </div>
    {p.kind==='post'&&data.related?.length>0&&<section className="container section" style={{paddingTop:'48px'}}>
      <div className="section-heading" style={{marginBottom:'28px'}}>
        <div>
          <span className="apple-eyebrow">Keep Reading</span>
          <h2>Related Guides</h2>
        </div>
        <a className="text-link" href="/blog/">All guides <ArrowRight size={16}/></a>
      </div>
      <div className="apple-cards-grid">
        {data.related.map((post,i)=><FuturisticCard post={post} index={i} key={post._id||post.slug}/>)}
      </div>
    </section>}
  </>;
}
function Listing({data}){
  if(data.query)return <PlatformSearch data={data}/>;
  return <FuturisticBlogHub data={data}/>;
}
function FooterStayConnected({ settings }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail)) {
      setErrorMsg('Please enter a valid work or Gmail address.');
      return;
    }
    setStatus('loading');
    setErrorMsg('');
    try {
      const res = await fetch('/api/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: cleanEmail,
          service: 'Weekly Growth Playbooks & 500+ Assets',
          source: 'footer-newsletter',
          notes: 'Subscribed from footer Stay connected form'
        })
      });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.error || 'Failed to subscribe.');
      trackLeadEvent('Weekly Growth Playbooks', 'Newsletter', 'footer-newsletter');
      setStatus('success');
      setEmail('');
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message || 'Subscription failed. Try again.');
    }
  };

  const contactEmail = settings.contactEmail || 'support@bizaipro.com';
  const socialLinks = settings.socialLinks?.length ? settings.socialLinks : [
    { label: 'X (Twitter)', url: 'https://x.com/bizaipro' },
    { label: 'LinkedIn', url: 'https://linkedin.com/company/bizaipro' },
    { label: 'GitHub', url: 'https://github.com/sajibhalder903-bit/bizaipro.com' }
  ];

  return (
    <div className="footer-col-connect">
      <b>Stay connected</b>
      <p className="footer-connect-desc">Get 500+ free digital assets & weekly AI growth blueprints.</p>
      {status === 'success' ? (
        <div className="footer-subscribe-success">
          <Check size={16} color="#10b981" />
          <span>You're subscribed! Welcome aboard.</span>
        </div>
      ) : (
        <form onSubmit={handleSubscribe} className="footer-subscribe-form">
          <div className="footer-subscribe-row">
            <input
              type="email"
              required
              placeholder="Your business email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={status === 'loading'}
              aria-label="Email for free weekly tools and playbooks"
            />
            <button type="submit" className="button small footer-sub-btn" disabled={status === 'loading'}>
              {status === 'loading' ? '...' : 'Join'}
            </button>
          </div>
          {errorMsg && <small className="footer-sub-error">{errorMsg}</small>}
          <small className="footer-sub-privacy">🔒 Zero spam. Unsubscribe anytime.</small>
        </form>
      )}
      <div className="footer-direct-contact">
        <a href={`mailto:${contactEmail}`} className="footer-email-link">{contactEmail}</a>
      </div>
      <div className="footer-social-links">
        {socialLinks.map((n) => (
          <a key={n.url} href={n.url} target="_blank" rel="noopener noreferrer">
            {n.label}
            <ArrowUpRight size={12} />
          </a>
        ))}
      </div>
    </div>
  );
}

export function GoogleOneTap({ settings }) {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      const member = localStorage.getItem('bizaipro_member');
      if (member) return;
    } catch {}

    const initOneTap = (clientId) => {
      if (!window.google?.accounts?.id || !clientId) return;
      try {
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: async (response) => {
            if (!response?.credential) return;
            try {
              const res = await fetch('/api/auth/google/verify', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  credential: response.credential,
                  slug: 'global-one-tap',
                }),
              });
              const data = await res.json();
              if (data?.ok && data?.member) {
                localStorage.setItem('bizaipro_member', JSON.stringify(data.member));
                window.dispatchEvent(new CustomEvent('bizaipro-auth-change', { detail: data.member }));
              }
            } catch (err) {
              console.warn('One-Tap auth note:', err);
            }
          },
          auto_select: false,
          cancel_on_tap_outside: false,
          itp_support: true,
        });
        window.google.accounts.id.prompt();
      } catch (e) {
        console.warn('Google One-Tap prompt note:', e);
      }
    };

    fetch('/api/auth/google/config')
      .then((r) => r.json())
      .then((data) => {
        const clientId = data?.clientId || settings?.googleClientId;
        if (!clientId) return;
        if (window.google?.accounts?.id) {
          initOneTap(clientId);
        } else {
          const script = document.createElement('script');
          script.src = 'https://accounts.google.com/gsi/client';
          script.async = true;
          script.defer = true;
          script.onload = () => initOneTap(clientId);
          document.head.appendChild(script);
        }
      })
      .catch(() => {});
  }, [settings?.googleClientId]);

  return null;
}

export default function App({data}){
 const [mounted,setMounted]=useState(false);const [globalAudit,setGlobalAudit]=useState(false);useEffect(()=>{setMounted(true);},[]);
 if(data.view==='admin')return mounted?<Suspense fallback={<div className="loading">Opening your studio...</div>}><Admin settings={data.settings}/></Suspense>:<div className="loading">Opening your studio...</div>;
 if(data.view==='crm'||data.view==='educationCrm')return mounted?<Suspense fallback={<div className="loading">Opening Akashbari Global Services CRM...</div>}><CrmApp data={data} settings={data.settings}/></Suspense>:<div className="loading">Opening Akashbari Global Services CRM...</div>;
 return <div className="platform" style={{'--accent':data.settings.accentColor}}><a href="#main" className="skip-link">Skip to content</a><PlatformHeader settings={data.settings} Brand={Brand}/><LiveMarketTicker initialOverview={data?.initialOverview}/><main id="main">{data.view==='learn'?<LearnPage data={data}/>:data.view==='home'?<PlatformHome data={data}/>:data.view==='pdfToolsHub'?<PdfToolsHub data={data}/>:data.view==='pdfWorkflow'?<PdfWorkflowBuilder data={data}/>:data.view==='pdfTool'?<PdfToolPage slug={data.slug} data={data}/>:data.view==='account'?<CustomerDashboard data={data}/>:data.view==='vault'?<DigitalVaultPage data={data}/>:data.view==='vaultItem'?<DigitalAssetDetailPage data={data}/>:data.view==='marketplace'?<MarketplacePage data={data}/>:data.view==='marketplaceProduct'?<MarketplaceProductPage data={data}/>:data.view==='markets'?<MarketDashboard data={data}/>:data.view==='tool'?(data.tool.engine==='studio'?<StudioPage data={data}/>:<PlatformToolPage data={data}/>):data.view==='listing'?<Listing data={data}/>:data.view==='article'?<Article data={data}/>:data.view==='tools'?<PlatformDirectory category={data.category}/>:data.view==='shop'?<ShopPage data={data}/>:data.view==='shopProduct'?<ShopProductPage data={data}/>:<section className="container section not-found"><span className="eyebrow">404</span><h1>Let's find your next step.</h1><p>This page isn't here. The guides and tools are a good place to start.</p><a className="button" href="/">Back to home<ArrowRight size={18}/></a></section>}</main><footer className="site-footer"><div className="container footer-grid"><div><Brand settings={data.settings}/><p>AI tools and automation for small business growth.</p><HostingerReferral/></div><div><b>Explore Tools</b><a href="/pdf-tools/">PDF Tools Hub (33 Tools)</a><a href="/pdf-tools/workflow-builder/">PDF Workflows</a>{toolCategories.map(([c,label])=><a key={c} href={'/tools/'+c+'/'}>{label}</a>)}<a href="/marketplace/">Digital Products</a><a href="/downloads/">Free Assets (500+)</a><a href="/free-tools/">All Free Tools</a><a href="/tools/business-studio/">Business Studio</a><a href="/shop/">Affiliate Shop</a></div><div><b>BizAIPro</b><a href="/learn/">Learn with BizAIPro</a><a href="/account/">My Account & Orders</a><a href="/markets/">Market Intelligence</a><a href="/blog/">Guides & Resources</a><a href="/sitemap/">Sitemap</a>{(data.settings.footerLinks||[]).map(n=><a key={n.url} href={n.url}>{n.label}</a>)}</div><FooterStayConnected settings={data.settings}/></div><div className="container footer-bottom"><span>© {new Date().getUTCFullYear()} {data.settings.siteName}. All rights reserved.</span><span>Smarter tools. Better business.</span></div></footer><GrowthAuditModal isOpen={globalAudit} onClose={()=>setGlobalAudit(false)}/></div>;
}
